import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useQuery } from '@apollo/client';
import { CurrentProgressBarContent } from '~/modules/common/components';
import { BATCH_QUERY } from '~/modules/common/components/BillingBatchStatus/BillingBatchStatus';
import { BatchState } from '~/types';

export const ProgressContent = ({
  batchId,
  itemCounts,
  setBillingBatchState,
  onBatchComplete
}) => {
  const { formatMessage } = useIntl();

  const { stopPolling, data: { getBillingBatchStatus = {} } = {} } = useQuery(
    BATCH_QUERY,
    {
      variables: {
        batchId
      },
      fetchPolicy: 'network-only',
      pollInterval: 500
    }
  );

  const { executionState, overallProgress } = getBillingBatchStatus;

  const hasProcessed =
    executionState === BatchState.Succeeded ||
    executionState === BatchState.Cancelled ||
    executionState === BatchState.Failed;

  useEffect(() => {
    if (!hasProcessed) return;
    stopPolling();
    onBatchComplete(overallProgress);
  }, [
    overallProgress,
    hasProcessed,
    stopPolling,
    batchId,
    setBillingBatchState,
    onBatchComplete
  ]);

  return (
    <CurrentProgressBarContent
      currentProgress={overallProgress?.currentProgress ?? 0}
      itemCounts={itemCounts}
      progressInfo={formatMessage({
        id: 'availableToBillList.undoInfoMessage'
      })}
    />
  );
};

ProgressContent.propTypes = {
  batchId: PropTypes.string,
  itemCounts: PropTypes.number,
  setBillingBatchState: PropTypes.func,
  onBatchComplete: PropTypes.func
};

export default ProgressContent;
